<template>
  <div class="d-inline-block">
    <v-img src="@/assets/icons/cheeers.small.png" v-bind="$attrs" />
  </div>
</template>

<script>
export default {
  name: 'CheeersIcon',
};
</script>

<style scoped></style>
